import qs from 'query-string';
import { handleApiError } from 'utils/apiUtils';

import { configAxios } from './apiConfig';
import { createLog } from './logService';

export const fetchSchoolDataFilter = async (dispatch, params) => {
  try {
    const query = qs.stringify(params, {
      skipEmptyString: true,
      skipNull: true,
    });

    const response = await configAxios.get(
      `school/update-data-filter?${query}`
    );

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getSchoolsFilters = async (params) => {
  try {
    const query = qs.stringify(params, {
      skipEmptyString: true,
      skipNull: true,
    });

    const { data } = await configAxios.get(
      `school/update-data-filter?${query}`
    );

    return data;
  } catch (error) {
    return createLog(error);
  }
};

export const getSchoolsFiltersV2 = async (params) => {
  try {
    const query = qs.stringify(params, {
      skipEmptyString: true,
      skipNull: true,
    });

    const response = await configAxios.get(`v2/schools/filter?${query}`);

    return response?.data;
  } catch (error) {
    return createLog(error);
  }
};

// TODO: Clean up this function
export const featchSchoolPaged = async (parameters) => {
  try {
    const param = qs.stringify(parameters, {
      skipEmptyString: true,
      skipNull: true,
    });
    const response = await configAxios.get(`school/paged?${param}`);
    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getSchools = async (parameters) => {
  try {
    const param = qs.stringify(parameters, {
      skipEmptyString: true,
      skipNull: true,
    });

    const response = await configAxios.get(`school/paged?${param}`);

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const getSchoolsV2 = async (parameters) => {
  try {
    const param = qs.stringify(parameters, {
      skipEmptyString: true,
      skipNull: true,
    });

    const response = await configAxios.get(`v2/schools?${param}`);

    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
};

export const fetchSchoolDetail = async (params) => {
  try {
    const qsParams = qs.stringify(params, {
      skipEmptyString: true,
      skipNull: true,
    });

    const response = await configAxios.get(`school/detail?${qsParams}`);

    response.data.needAccommodation =
      params.accommodationId > 0 && params.bedroomType > 0;

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getSchoolDetails = async (params) => {
  try {
    const qsParams = qs.stringify(params, {
      skipEmptyString: true,
      skipNull: true,
    });

    const response = await configAxios.get(`school/detail?${qsParams}`);

    const schoolDetail = response?.data;

    if (!schoolDetail?.id) {
      return null;
    }

    schoolDetail.needAccommodation =
      params.accommodationId > 0 && params.bedroomType > 0;

    return schoolDetail;
  } catch (error) {
    return createLog(error);
  }
};

export const fetchSchoolImages = async (id) => {
  try {
    const qsParams = qs.stringify({
      id,
    });
    const response = await configAxios.get(`school/images?${qsParams}`);

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const getMainSchoolImage = async (id) => {
  try {
    const response = await configAxios.get(
      `school/image?${qs.stringify({ id })}`
    );

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};

export const fetchCountries = async () => {
  try {
    const response = await configAxios.get(
      `country/update-filter-by-courseType`
    );
    return response.data;
  } catch (error) {
    return createLog(error);
  }
};
